import { HttpContextToken } from '@angular/common/http';

/**
 * Set on a request whose 401 or 403 answers a question rather than ending the session, so
 * AuthInterceptor doesn't sign the user out over it. "Add to STAC" (plans/stac-conversion-eetaskapi.md
 * §8.2) answers 403 when the user's plan doesn't include it, or they can't see the task, and the
 * page then just hides the feature. Any other request still signs the user out on a 401 or 403.
 */
export const KEEP_SESSION_ON_DENIAL = new HttpContextToken<boolean>(() => false);
